<template>
  <Modal
    v-model="showAddModel"
    title="新增服务类型"
    :mask-closable="false"
    width="600"
    @on-cancel="quxiao"
  >
    <Input
      class="modelInput"
      v-model="modelInput"
      size="large"
      placeholder="请输入服务类型"
    />
    <div class="label-icon">
      <div>请选择图标</div>
      <RadioGroup v-model="selectRadio" class="radio-group">
        <Radio v-for="(item,index) in radioType" :label="item.type" class="icon-item">
          <div class="icon-wrapper" :style="{backgroundColor:item.color}" :title="item.name">
            <div class="iconfont icon" :class="item.icon"></div>
          </div>
        </Radio>
      </RadioGroup>
    </div>
    <div slot="footer">
      <Button @click="quxiao">取消</Button>
      <Button type="primary" @click="queding">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    props:{
      showAddModel:{
        type:Boolean,
        default:false
      }
    },
    data () {
      return {
        modelInput:'',
        radioType:[{
          type:'breakfast',
          icon:'icon-zaocan',
          color:'#ff8e2e',
          name:'早餐店'
        },{
          type:'farmer',
          icon:'icon-caishichang',
          color:'#9bcf50',
          name:'菜市场'
        },{
          type:'haircut',
          icon:'icon-lifadian',
          color:'#43bdf0',
          name:'理发店'
        },{
          type:'pharmacy',
          icon:'icon-yiliao',
          color:'#45ae76',
          name:'社区医疗'
        },{
          type:'park',
          icon:'icon-tingchechang',
          color:'#fcba28',
          name:'停车场'
        },{
          type:'maintenance',
          icon:'icon-xiuchedian',
          color:'#0ca3d2',
          name:'修车铺'
        },{
          type:'hardware',
          icon:'icon-wujindian',
          color:'#5d82d2',
          name:'五金店'
        },{
          type:'market',
          icon:'icon-chaoshi1',
          color:'#f44321',
          name:'超市'
        }],
        selectRadio:''
      }
    },
    methods: {
      quxiao(){
        this.$emit('closeAdd')
      },
      queding () {
        var that = this
        if (!that.modelInput) {
          that.$Message.warning('请填写服务类型名称')
          return
        }
        if (!that.selectRadio) {
          that.$Message.warning('请选择图标')
          return
        }
        var url = this.urlobj.addLabel()
        this.$post(url,{
          labelType:'4',
          name:that.modelInput,
          labelValue:that.selectRadio
        }).then(res => {
          if (res.isSucceed) {
            that.$Message.success('添加成功')
            that.$emit('addLabel')
          }
        })
      }
    }
  }
</script>

<style scoped>
  .radio-group{
    display: flex;
    flex-wrap: wrap;
    margin-top:20px;
    padding-bottom: 100px;
  }
.label-icon{
  font-size: 15px;
  margin-top: 20px;
}
.icon-item{
  margin-right:58px;
  margin-bottom:20px;
  display: flex;
  align-items: center;
}
  .icon-wrapper{
    height: 30px;
    width: 30px;
    border-radius: 100%;
    margin-left:5px
  }
  .icon{
    color:#fff;
    font-size: 26px;
    margin-top: -4px;
    margin-left:2px
  }
</style>
